// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Modifier-Detail-ModifierForm-__ModifierForm___2Az4H","content-wrapper":"app-pages-Library-Modifier-Detail-ModifierForm-__ModifierForm___7qIBc"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierForm.css
// module id = 2188
// module chunks = 0